import React from 'react'
import PropTypes from 'prop-types'

import Tag from '@components/tag/tag.component'

import useStyles from './engagement-detail-header.style'

const EngagementDetailHeader = ({ title, usersMessaged, parentTitle, ...props }) => {
  const classes = useStyles(props)

  return (
    <div className={classes.container}>
      <div className={classes.parentTitle}>{parentTitle}</div>
      <div className={classes.wrapper}>
        <div className={classes.title}>{title}</div>
      </div>
      <div className={classes.tag}>
        <Tag
          backgroundColor='rgba(58, 197, 227, 0.2)'
          color='#1EAEFF'
          size='small'
          text={usersMessaged}
        />
      </div>
    </div>
  )
}

EngagementDetailHeader.defaultProps = {
  parentTitle: '',
  title: '',
  usersMessaged: ''
}

EngagementDetailHeader.propTypes = {
  parentTitle: PropTypes.string,
  title: PropTypes.string,
  usersMessaged: PropTypes.string
}

export default EngagementDetailHeader
